import React from 'react'

import { BaseView, BaseText } from '@/components/base'
import { useTheme } from '@/hooks/useTheme'

interface AvatarProps {
  uri?: string | null
  onPress?: () => void
  skeletonActive?: boolean
  firstName?: string
}

export const Avatar: React.FC<AvatarProps> = ({
  uri,
  onPress,
  skeletonActive = false,
  firstName,
}) => {
  const theme = useTheme()

  if (skeletonActive) {
    return (
      <BaseView
        circle
        circleSize={44}
        bgColor="background.secondaryGray"
        className="animate-pulse"
        style={{
          backgroundColor: theme.colors.background.secondaryGray,
        }}
      />
    )
  }

  return (
    <BaseView
      circle
      circleSize={44}
      bgColor="background.secondaryGray"
      center
      style={{
        backgroundColor: theme.colors.background.secondaryGray,
        cursor: 'pointer',
      }}
      onClick={onPress}
    >
      {uri ? (
        <img
          src={uri}
          alt="Avatar"
          style={{
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />
      ) : (
        <BaseText
          fontSize={18}
          fontFamily="semibold"
          color="label.buttonPrimaryEnabled"
        >
          {firstName ? firstName.charAt(0).toUpperCase() : 'U'}
        </BaseText>
      )}
    </BaseView>
  )
}
